module.exports = __webpack_public_path__ + "static/media/Soul soffa 3-sits divan XL genisis lion miljö 2023.dd67147a.jpg";